import script from "./SubIvaTotal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubIvaTotal.vue?vue&type=script&setup=true&lang=ts"

import "./SubIvaTotal.vue?vue&type=style&index=0&id=6948c088&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6948c088"]])

export default __exports__